import { combineReducers } from 'redux'
import {
  ActionFunctionAny,
  Action,
  ReduxCompatibleReducer,
  createAction,
  handleActions,
} from 'redux-actions'

import { IBot } from 'pages/App/components/Sidebar/SidebarInfo/Bots'
import * as constants from './constants'

export interface IBotsStatusAction {
  type: typeof constants.FETCH_BOTS
  payload: Array<IBot> | null
}

// Actions
export const fetchBots: ActionFunctionAny<Action<Array<
  IBot
> | null>> = createAction(constants.FETCH_BOTS)

// Reducers
const list: ReduxCompatibleReducer<
  Array<IBot> | null,
  Array<IBot> | null
> = handleActions(
  {
    [constants.FETCH_BOTS]: (_state: Array<IBot> | null, action) =>
      action.payload,
  },
  null
)

const fetched: ReduxCompatibleReducer<boolean, boolean> = handleActions(
  {
    [constants.FETCH_BOTS]: () => true,
  },
  false
)

export const initialState: BotState = {
  list: null,
  fetched: false,
}

const bots = combineReducers({
  list,
  fetched,
})

export type BotState = ReturnType<typeof bots>
export default bots
